export const sponsoredSearchTileMedia: App.Image = { id: 'search-tile-ads-hero' }
export const sponsoredSearchTileLogo: App.Image = { id: 'search-tile-ads-paypal' }
